export default __webpack_public_path__ + "static/media/Wristwraps of the Harbinger.55d7e453.jpg";